import {
  Component,
  EventEmitter,
  Input,
  ViewChild,
  Output,
  
} from '@angular/core';
import { AccountsService } from 'src/app/shared/services/accounts/accounts.service';
import { NgbDropdown, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash'
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { APP_CONST } from 'src/app/shared/constants/app-constants';
import { SidebarService } from "../../../../shared/services/sidebar/sidebar.service";
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { URLS_CONST } from 'src/app/shared/constants/url-constants';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { environment } from 'src/environments/environment';
import { ManagersService } from 'src/app/shared/services/managers/managers.service';
import { NgIf, NgClass, NgFor } from '@angular/common';
import { LtmsLoaderComponent } from '../../../../shared/components/ltms-loader/ltms-loader.component';
import { ScoreSearchBarComponent } from '../../../../shared/components/score/score-search-bar/score-search-bar.component';
import { ScoreDropdownMenuComponent } from '../../../../shared/components/score/score-dropdown-menu/score-dropdown-menu.component';

@Component({
    selector: 'app-account-list-home',
    templateUrl: './account-list-home.component.html',
    styleUrls: ['./account-list-home.component.scss'],
    imports: [NgIf, LtmsLoaderComponent, ScoreSearchBarComponent, ScoreDropdownMenuComponent, NgClass, NgFor, NgbTooltip, TranslateModule]
})
export class AccountListHomeComponent {
  
  isLoading: boolean = true; 
  originalAccountsData: any;
  accountsData: any;
  newOption: any;
  searchItem: any;
  // from userData
  managerID!: string;
  currentSelection!: any;
  showNoAccountsMessage: boolean = false;
  showCreateAccountButton: boolean = true;
  isSearchPerformed: boolean = false;
  showLoader = false;

  options: { name: string; id: number; value: string }[] = [
    { name: 'Name', id: 1, value: 'name' },
    { name: 'Live', id: 2, value: 'live_projects' },
    { name: 'On Hold', id: 3, value: 'on_hold_projects' },
    { name: 'Setup', id: 4, value: 'setup_projects' },
    { name: 'Closed', id: 5, value: 'closed_projects' },
    { name: 'Archived', id: 6, value: 'archive_projects' },
    { name: 'Total projects', id: 7, value: 'total_projects' },
  ];
  selectedOption: string = '';
   showMainContent = true;
   loaderMessage:string = '';

  @ViewChild(NgbDropdown) dropdown: NgbDropdown | undefined;
  
  constructor(
    private AccountsService: AccountsService,
    private translate: TranslateService,
    private router: Router,
    private sidebarService: SidebarService,
    private headerService: HeaderService,
    private _helpers: HelpersService,
    private managersService: ManagersService,
      private _router: Router,
  ) {
    this.newOption = '';
    translate.setDefaultLang('en');
    translate.use('en');
    // this.sidebarService.updateSidebarVisibility(false);
    this.headerService.setHeaderState({ showCalendarButton: false });
  }

  ngOnDestroy() {
    // this.sidebarService.updateSidebarVisibility(true);
    this.headerService.setHeaderState({ showCalendarButton: true });
    this.headerService.toggleSignedInAsButtonVisibility(true);
  }


  useLanguage(language: string) {
    this.translate.setDefaultLang(language);
    this.translate.use(language);
  }

  setCurrentSelection(option: any) {
    this.selectedOption = option.name ? option.name : option;
    this.currentSelection = option
    if (option && option.value === 'name') {
      this.accountsData = this.accountsData.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    } else {
      this.accountsData = _.sortBy(this.accountsData, [option.value]).reverse();
    }
    if (this.dropdown) {
      this.dropdown.close();
    }
  }

  searchData(event: string) {
    this.searchItem = event;
    this.isSearchPerformed = true;
  
    if (!this.searchItem) {
      this.isSearchPerformed = false;
      this.showNoAccountsMessage = false;
      this.showCreateAccountButton = true;
    }
  
    let filteredData = this.originalAccountsData;
    if (this.searchItem) {
      filteredData = this.originalAccountsData.filter(account =>
        account.name.toLowerCase().includes(this.searchItem.toLowerCase())
      );
    }
  
    if (filteredData.length === 0) {
      this.showNoAccountsMessage = true;
      this.showCreateAccountButton = false; 
    } else {
      this.showNoAccountsMessage = false;
      this.showCreateAccountButton = true;
    }
  
    if (this.currentSelection && this.currentSelection.value) {
      if (this.currentSelection.value === 'name') {
        filteredData = filteredData.sort((a, b) => a.name.localeCompare(b.name));
      } else {
        filteredData = _.sortBy(filteredData, [this.currentSelection.value]).reverse();
      }
    }
  
    this.accountsData = filteredData;
  }
  
 userCurrentAccess() {
  this.showMainContent = false;
  this.loaderMessage = 'Checking access from helpers...';
  const manager = this._helpers.helpers['managerDetails']?.manager;
  if (manager && (manager.is_lw3_permitted_user || manager.allowed_dashboard_versions?.includes('v3'))) {
    // Call managersService.getAccess directly with handlers
    this.managersService.getAccess(manager, {
      gotoProject: (accountId, projectId) => this.gotoProject(accountId, projectId),
      gotoDashboard: (accountId) => this.gotoDashboard(accountId),
      gotoAccounts: () => this.gotoAccounts(),
      setError: (msg) => this.setError(msg),
      setShowLoader: (val) => this.showLoader = val,
      setLoaderMessage: (msg) => this.loaderMessage = msg,
    });
  } else {
    this._router.navigate([APP_CONST.ROUTE_LOGIN]);
    this.loaderMessage = 'Redirecting to login...';
    this.showMainContent = true;
  }
}

   setError(message: string) {
   
    this.showMainContent = true; // Show main content after setting error
   }
   

  gotoDashboard(accountId: string) {
      this._router.navigate([APP_CONST.ROUTE_ACCOUNT_DETAILS], {
        queryParams: { account_id: accountId }
      });
    }
  
    gotoProject(accountId: string, projectId: string, activeTab: string = 'trends') {
      this._router.navigate([APP_CONST.ROUTE_PROJECT_DETAILS], {
        queryParams: {
          account_id: accountId,
          project_id: projectId,
          active_tab: activeTab
        }
      });
    }
    
    gotoAccounts() {
      this._router.navigate([APP_CONST.ROUTE_ACCOUNTS]);
    }
    gotoLogin() {
      this._router.navigate([APP_CONST.ROUTE_LOGIN]);
    }
  
  ngOnInit() {
    // taking managerId from login page
    // const state = window.history.state;
    this.managerID = _.get(Helpers, "managerDetails.manager._id")
    this.currentSelection = this.options[0];
    this.getAccountsData(this.managerID);
    // this.headerService.setLogoUrl(URLS_CONST.LITMUS_LOGO_URL);
    this.headerService.toggleSignedInAsButtonVisibility(false);
    this.userCurrentAccess();
  }

  getTotalProjectsForAccount(account: any): number {
    return account.setup_projects +
      account.live_projects +
      account.on_hold_projects +
      account.closed_projects +
      account.archive_projects;
  }

  getAccountsData(managerID) {
    this.isLoading = true;
    this.AccountsService.getAccounts(managerID).subscribe(
      (response) => {
        if (response.data.code === 4053) {
          // Redirect to the login page
          this.router.navigate([APP_CONST.ROUTE_LOGIN]);
        } else {
          // fillter the list for LW3 Permitted Account List
         // response.data.account_details = this.getLw3PermittedAccountList(response.data.account_details)
          if(response.data.account_details && response.data.account_details.length > 0){
            // Process the response data 
            this.originalAccountsData = response.data.account_details;
            this.accountsData = [...this.originalAccountsData];
            this.setCurrentSelection(this.currentSelection);
          }else{
            // AccountNotAllowedOnLW3
            this.router.navigate(["message"], { queryParams: { status: '402' } });
          }
        }
        this.isLoading = false;
      },
      (error) => {
        console.error('Error during API call:', error);
        this.isLoading = false;
      }
    );
  }

  // check if is_lw3_permitted_account enabled and has account details has same details.
  getLw3PermittedAccountList(account_details) {
     if (environment && environment['is_lw3_permitted_account'] && environment['is_lw3_permitted_account'] == true) {
        return _.filter(account_details, {  "is_lw3_permitted_account": true})
     } else {
        return account_details;
     }
  }

  navigateTo(route: string, accountId?: string) {
    if (route === 'create') {
      this.router.navigate([APP_CONST.ROUTE_ACCOUNT_CREATE])
    } else if (route === 'details') {
      this.router.navigate([APP_CONST.ROUTE_ACCOUNT_DETAILS], { queryParams: { account_id: accountId } });
    }
  }
}